import EventBus from "@/eventBus";
import {
  $getZoneByCoords,
  $getWashersByZone,
  $getWashersByZoneWashOut2,
  $getPrices,
  $postLogin,
  $postRegistration,
  $getUserData,
  $verifyEmailCode,
  $verifyEmailRequest,
  $verifyPhoneCode,
  $verifyPhoneRequest,
  $sendResetPasswordMail,
  $reserveWashing,
  $getBraintreeToken,
  $getCouponsByCouponCode,
  $getCouponsByUserId,
  $getUsedCoupons,
  $postCoupon,
  $patchRegistration,
  $editWashing,
  $deleteWashing,
} from "@/utils/endpoints";

import { getGTAGtimeslotTrackingObject } from '@/utils/generic';

export const state = () => ({
  addressAutocompleteOptions: {
    fields: ["address_components", "formatted_address", "geometry"],
    componentRestrictions: { country: "it" },
  },
  selectedAddress: null,
  isStreetNumberVisible: false,
  addressStreetNumber: undefined,
  hasAddressChanged: false,
  selectedZone: null,
  isExternalWashingAccordionDisabled: false,
  isInternalWashingAccordionDisabled: false,
  isHygienizationAccordionDisabled: false,
  performances: [],
  performancesAccordions: [],
  selectedPerformances: [],
  selectedDay: null,
  hours: [],
  hoursWashOut2: {},
  selectedHours: {},
  selectedVehicleAccessOption: "",
  selectedDirtinessPercentages: {
    external: 0,
    internal: 0,
  },
  travelsWithPets: false,
  selectedAdditionalDetails: "",
  selectedVehicleAccessDetails: "",
  totalAmount: null,
  toBePayed: 0,
  bookingStep: "booking",
  isSigninIn: false,
  isSigninUp: true,
  verificationCode: "",
  isVerificationCodeValid: false,
  shouldShowVerificationErrors: false,
  isValidationCodeBtnDisabled: false,
  lastMailVerificationCodeRequested: null,
  lastPhoneVerificationCodeRequested: null,
  userData: null,
  mailCodeVerificationState: null,
  phoneCodeVerificationState: null,
  name: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  password: "",
  passwordConfirmation: "",
  isAgreementAccepted: false,
  isFormValid: false,
  fiscalCode: "",
  cap: "",
  taxDetailsAddress: "",
  taxDetailsCity: "",
  selectedProvince: null,
  selectedNation: null,
  shouldShowRegistrationErrors: false,
  registrationState: null,
  businessName: null,
  vatNumber: null,
  pec: null,
  sdiCode: null,
  loginUsername: "",
  loginPassword: "",
  loginState: null,
  hasFinishedFunnel: false,
  resetPasswordMailSent: false,
  reserveWashingState: null,
  userCoupons: [],
  usableUserCoupons: [],
  usedCouponsQuantity: null,
  selectedCoupon: null,
  expiredCoupons: [],
  availableCouponsForUse: [],
  couponsUsedByUser: [],
  paymentToken: null,
  isPaymentInfoValid: false,
  selectedPayment: "",
  nonce: "",
  paypalInstance: null,
  garageUrl:
    process.env.NODE_ENV === "development"
      ? "https://www-dev.washout-app.com/account/garage"
      : "https://www.washout-app.com/account/garage",
  braintreeOptions: {
    styles: {
      input: {
        "font-size": "14px",
      },
    },
    fields: {
      number: {
        selector: "#number",
        placeholder: "1111 1111 1111 1111",
      },
      cvv: {
        selector: "#cvv",
        placeholder: "cvv",
      },
      expirationDate: {
        selector: "#expiration-date",
        placeholder: "Data di scadenza",
      },
    },
  },
  braintreeDropInOptions: {
    container: "#dropin-container",
    card: {
      cvv: {
        required: true,
      },
      cardholderName: {
        required: true,
      },
    },
    locale: "it_IT",
    threeDSecure: true,
    overrides: {
      styles: {
        input: {
          width: "100%",
        },
      },
    },
  },
  hostedFields: {},
  expiration: null,
  hasSetCoupon: false,
  couponState: {},
  registrationPatchState: null,
  areTaxDetailsChanged: false,
  editingWashing: null,
  editingWashingState: null,
  deletingWashingState: null,
  selectedVehicleForWashing: {
    id: null,
    model: "",
    brand: "",
    number_plate: "",
    vehicle_type_id: "",
    color: "",
    car_id: "",
  },
  newVehicle: {
    id: -1,
    model: "",
    brand: "",
    number_plate: "",
    vehicle_type_id: "",
    color: "",
    car_id: "",
  },
});

const defaultState = state();
const paypalEnviroment =
  process.env.NODE_ENV === "development" ? "sandbox" : "production";

const getters = {
  addressAutocompleteOptions: (state) => state.addressAutocompleteOptions,
  selectedAddress: (state) => state.selectedAddress,
  isStreetNumberVisible: (state) => state.isStreetNumberVisible,
  addressStreetNumber: (state) => state.addressStreetNumber,
  selectedZone: (state) => state.selectedZone,
  isExternalWashingAccordionDisabled: (state) =>
    state.isExternalWashingAccordionDisabled,
  isInternalWashingAccordionDisabled: (state) =>
    state.isInternalWashingAccordionDisabled,
  isHygienizationAccordionDisabled: (state) =>
    state.isHygienizationAccordionDisabled,
  performances: (state) => state.performances,
  performancesAccordions: (state) => state.performancesAccordions,
  selectedPerformances: (state) => state.selectedPerformances,
  selectedDay: (state) => state.selectedDay,
  hours: (state) => state.hours,
  hoursWashOut2: (state) => state.hoursWashOut2,
  selectedHours: (state) => state.selectedHours,
  selectedVehicleAccessOption: (state) => state.selectedVehicleAccessOption,
  selectedDirtinessPercentages: (state) => state.selectedDirtinessPercentages,
  travelsWithPets: (state) => state.travelsWithPets,
  selectedAdditionalDetails: (state) => state.selectedAdditionalDetails,
  selectedVehicleAccessDetails: (state) => state.selectedVehicleAccessDetails,
  totalAmount: (state) => state.totalAmount,
  toBePayed: (state) => state.toBePayed,
  bookingStep: (state) => state.bookingStep,
  isSigninIn: (state) => state.isSigninIn,
  isSigninUp: (state) => state.isSigninUp,
  verificationCode: (state) => state.verificationCode,
  isVerificationCodeValid: (state) => state.isVerificationCodeValid,
  shouldShowVerificationErrors: (state) => state.shouldShowVerificationErrors,
  isValidationCodeBtnDisabled: (state) => state.isValidationCodeBtnDisabled,
  lastMailVerificationCodeRequested: (state) =>
    state.lastMailVerificationCodeRequested,
  lastPhoneVerificationCodeRequested: (state) =>
    state.lastPhoneVerificationCodeRequested,
  userData: (state) => state.userData,
  mailCodeVerificationState: (state) => state.mailCodeVerificationState,
  phoneCodeVerificationState: (state) => state.phoneCodeVerificationState,
  name: (state) => state.name,
  lastName: (state) => state.lastName,
  phoneNumber: (state) => state.phoneNumber,
  email: (state) => state.email,
  password: (state) => state.password,
  passwordConfirmation: (state) => state.passwordConfirmation,
  isAgreementAccepted: (state) => state.isAgreementAccepted,
  isFormValid: (state) => state.isFormValid,
  fiscalCode: (state) => state.fiscalCode,
  cap: (state) => state.cap,
  taxDetailsAddress: (state) => state.taxDetailsAddress,
  taxDetailsCity: (state) => state.taxDetailsCity,
  selectedProvince: (state) => state.selectedProvince,
  selectedNation: (state) => state.selectedNation,
  shouldShowRegistrationErrors: (state) => state.shouldShowRegistrationErrors,
  registrationState: (state) => state.registrationState,
  businessName: (state) => state.businessName,
  vatNumber: (state) => state.vatNumber,
  pec: (state) => state.pec,
  sdiCode: (state) => state.sdiCode,
  loginUsername: (state) => state.loginUsername,
  loginPassword: (state) => state.loginPassword,
  loginState: (state) => state.loginState,
  hasFinishedFunnel: (state) => state.hasFinishedFunnel,
  resetPasswordMailSent: (state) => state.resetPasswordMailSent,
  reserveWashingState: (state) => state.reserveWashingState,
  userCoupons: (state) => state.userCoupons,
  usableUserCoupons: (state) => state.usableUserCoupons,
  usedCouponsQuantity: (state) => state.usedCouponsQuantity,
  selectedCoupon: (state) => state.selectedCoupon,
  expiredCoupons: (state) => state.expiredCoupons,
  availableCouponsForUse: (state) => state.availableCouponsForUse,
  couponsUsedByUser: (state) => state.couponsUsedByUser,
  paymentToken: (state) => state.paymentToken,
  isPaymentInfoValid: (state) => state.isPaymentInfoValid,
  selectedPayment: (state) => state.selectedPayment,
  nonce: (state) => state.nonce,
  paypalInstance: (state) => state.paypalInstance,
  dropInInstance: (state) => state.dropInInstance,
  garageUrl: (state) => state.garageUrl,
  braintreeOptions: (state) => state.braintreeOptions,
  braintreeDropInOptions: (state) => state.braintreeDropInOptions,
  hostedFields: (state) => state.hostedFields,
  expiration: (state) => state.expiration,
  hasSetCoupon: (state) => state.hasSetCoupon,
  couponState: (state) => state.couponState,
  registrationPatchState: (state) => state.registrationPatchState,
  areTaxDetailsChanged: (state) => state.areTaxDetailsChanged,
  editingWashing: (state) => state.editingWashing,
  isEditingWashing: (state) =>
    state.editingWashing &&
    (!!state.editingWashing.id || state.editingWashing.id === 0),
  workingTime: (state) => 
    state.performancesAccordions.find(x => !x.isVisible).option.working_time + 
    state.selectedPerformances.reduce((tot, { working_time }) => (tot += working_time), 0),
  hasAddressChanged: (state) => state.hasAddressChanged,
  editingWashingState: (state) => state.editingWashingState,
  deletingWashingState: (state) => state.deletingWashingState,
  selectedVehicleForWashing: (state) => state.selectedVehicleForWashing,
  newVehicle: (state) => state.newVehicle,
};
const mutations = {
  selectAddress: (state, newValue) => {
    state.selectedAddress = newValue;
  },
  setHasAddressChanged: (state, newValue) =>
    (state.hasAddressChanged = newValue),
  setAddressStreetNumber: (state, newValue) =>
    (state.addressStreetNumber = newValue),
  toggleStreetNumberVisibility: (state) => {
    state.isStreetNumberVisible = !state.isStreetNumberVisible;
  },
  setZone(state, zone) {
    state.selectedZone = zone;
  },
  resetZone(state) {
    state.selectedZone = null;
  },
  setBrands(state, brands) {
    state.brands = brands;
  },
  selectBrand(state, brand) {
    state.selectedBrand = brand;
    state.selectedModel = {};
    state.selectedPerformances = [];
    state.performancesAccordions = [];
  },
  setBrandModels(state, brandModels) {
    state.brandModels = brandModels;
  },
  selectModel(state, model) {
    state.selectedModel = model;
    state.selectedPerformances = [];
    state.performancesAccordions = [];
  },
  toggleColorsAccordion(state) {
    state.isColorsAccordionOpen = !state.isColorsAccordionOpen;
  },
  selectColor(state, color) {
    state.selectedColor = color;
    state.isColorsAccordionOpen = false;
  },
  selectLicensePlate(state, plate = "") {
    state.licensePlate = plate.toUpperCase();
  },
  togglePerformanceAccordion(state, id) {
    state.performancesAccordions = state.performancesAccordions.map(
      (performance) => {
        const { option, isOpen } = performance;
        if (option.id === id) {
          return { ...performance, isOpen: !isOpen };
        }
        return { ...performance, isOpen };
      }
    );
  },
  selectPerformance(state, selectedOption) {
    let isToAdd = undefined;
    state.performancesAccordions = state.performancesAccordions.map(
      (performance) => {
        const { option, isSelected } = performance;
        if (option.id === selectedOption.id) {
          isToAdd = !isSelected;
          return { ...performance, isSelected: !isSelected };
        }
        return { ...performance, isSelected };
      }
    );
    if(isToAdd && !state.selectedPerformances.find(x => x.id == selectedOption.id)) {
      state.selectedPerformances.push(selectedOption);
    } else {
      state.selectedPerformances = state.selectedPerformances.filter(x => x.id != selectedOption.id);
    }
  },
  setPerformances(
    state,
    { performances, selectedPerformances, performancesAccordions }
  ) {
    state.performances = performances;
    state.selectedPerformances = selectedPerformances;
    state.performancesAccordions = performancesAccordions;
  },
  selectDay(state, day) {
    state.selectedDay = day;
  },
  setAvailabilityHours(state, hours) {
    state.hours = hours;
  },
  setAvailabilityHoursWashOut2(state, hours) {
    state.hoursWashOut2 = hours;
  },
  selectHours(state, options) {
    state.selectedHours = (options || {}).hours || {};

    if(!options || !options.gtag || !options.hours || !options.hours.formattedTime) return;
    options.gtag.event("time_selected", getGTAGtimeslotTrackingObject(options.hours));
  },
  selectVehicleAccessOption(state, option) {
    state.selectedVehicleAccessOption = option;
  },
  selectDirtinessPercentage(state, { type, value }) {
    if (type === "external") {
      state.selectedDirtinessPercentages.external = value;
    } else {
      state.selectedDirtinessPercentages.internal = value;
    }
  },
  selectTravelsWithPets(state, value) {
    state.travelsWithPets = value;
  },
  selectAdditionalDetails(state, value) {
    state.selectedAdditionalDetails = value;
  },
  selectVehicleAccessDetails(state, details) {
    state.selectedVehicleAccessDetails = details;
  },
  setTotalAmount(state, amount) {
    state.totalAmount = amount;
  },
  setToBePayed(state, amount) {
    state.toBePayed = amount;
  },
  setBookingStep(state, value) {
    state.bookingStep = value;
  },
  setName(state, value) {
    state.name = value;
  },
  setLastName(state, value) {
    state.lastName = value;
  },
  setPhoneNumber(state, value) {
    state.phoneNumber = value;
  },
  setEmail(state, value) {
    state.email = value;
  },
  setPassword(state, value) {
    state.password = value;
  },
  setPasswordConfirmation(state, value) {
    state.passwordConfirmation = value;
  },
  setAgreementAcceptance(state, value) {
    state.isAgreementAccepted = value;
  },
  setFormValidityState(state, value) {
    state.isFormValid = value;
  },
  setFiscalCode(state, value) {
    state.fiscalCode = value.toUpperCase();
    state.areTaxDetailsChanged = true;
  },
  setCap(state, value) {
    state.cap = value;
    state.areTaxDetailsChanged = true;
  },
  setTaxDetailsAddress(state, value) {
    state.taxDetailsAddress = value;
    state.areTaxDetailsChanged = true;
  },
  setTaxDetailsCity(state, value) {
    state.taxDetailsCity = value;
    state.areTaxDetailsChanged = true;
  },
  selectProvince(state, value) {
    state.selectedProvince = value;
    state.areTaxDetailsChanged = true;
  },
  selectNation(state, value) {
    state.selectedNation = value;
    state.areTaxDetailsChanged = true;
  },
  setBusinessName(state, value) {
    state.businessName = value;
    state.areTaxDetailsChanged = true;
  },
  setVatNumber(state, value) {
    state.vatNumber = value;
    state.areTaxDetailsChanged = true;
  },
  setPec(state, value) {
    state.pec = value;
    state.areTaxDetailsChanged = true;
  },
  setSdiCode(state, value) {
    state.sdiCode = value;
    state.areTaxDetailsChanged = true;
  },
  setShouldShowRegistrationErrors(state, value) {
    state.shouldShowRegistrationErrors = value;
  },
  postRegistration(state, value) {
    state.registrationState = value;
  },
  patchRegistration(state, value) {
    state.registrationPatchState = value;
  },
  deleteRegistrationSensibleInfo(state) {
    state.name = "";
    state.lastName = "";
    state.email = "";
    state.password = "";
    state.passwordConfirmation = "";
    state.fiscalCode = "";
    state.cap = "";
    state.taxDetailsAddress = "";
    state.taxDetailsCity = "";
    state.selectedProvince = null;
    state.selectedNation = null;
    state.businessName = null;
    state.vatNumber = null;
    state.pec = null;
    state.sdiCode = null;
    state.name = "";
    state.lastName = "";
    state.phoneNumber = "";
  },
  setLoginUsername(state, value) {
    state.loginUsername = value;
  },
  setLoginPassword(state, value) {
    state.loginPassword = value;
  },
  postLogin(state, value) {
    state.loginState = value;
  },
  deleteLoginSensibleInfo(state) {
    state.loginUsername = "";
    state.loginPassword = "";
  },
  setSigninUpState(state, value) {
    state.isSigninIn = false;
    state.isSigninUp = value;
  },
  setSigninInState(state, value) {
    state.isSigninUp = false;
    state.isSigninIn = value;
  },
  setVerificationCode(state, value) {
    state.verificationCode = value;
  },
  setIsVerificationCodeValid(state, value) {
    state.isVerificationCodeValid = value;
  },
  lastMailVerificationCodeRequested(state, value) {
    state.lastMailVerificationCodeRequested = value;
  },
  lastPhoneVerificationCodeRequested(state, value) {
    state.lastPhoneVerificationCodeRequested = value;
  },
  getUserData(state, value) {
    state.userData = value;
  },
  setResetPasswordMailSent(state, value) {
    state.resetPasswordMailSent = value;
  },
  reserveWashing(state, value = []) {
    state.reserveWashingState = value;
  },
  getCouponsByUserId(state, value) {
    state.userCoupons = value;
    state.usableUserCoupons = value.filter(
      ({ used, count, expiration }) =>
        used < count && new Date(expiration).getTime() > new Date().getTime()
    );
  },
  getCouponsByCouponCode(state, value) {
    const filtered = value.filter(({ used, count }) => used >= count);
    state.usedCouponsQuantity = filtered;
    state.availableCouponsForUse = filtered;
  },
  setSelectedCoupon(state, value) {
    state.selectedCoupon = value;
  },
  setCouponState(state, value) {
    state.couponState = value;
  },
  setExpiredCoupons(state, value) {
    state.expiredCoupons = value;
  },
  setAvailableCouponsForUse(state, value) {
    state.availableCouponsForUse = value;
  },

  getWashingsByUserId(state, value) {
    // ACCUMULATE ALL USER'S USED COUPONS FOR CHECKING IF HE'S ABLE TO USE THE COUPONS IN THE CONFIG
    state.couponsUsedByUser = value.reduce((acc, { coupons }) => {
      if (coupons && !acc.includes(coupons)) {
        acc = [...acc, coupons];
      }
      return acc;
    }, []);
  },
  getBraintreeToken(state, value) {
    state.paymentToken = value;
  },
  setPaymentInfoValidity(state, value) {
    state.isPaymentInfoValid = value;
  },
  setSelectedPayment(state, value) {
    state.selectedPayment = value;
  },
  setNonce(state, value) {
    state.nonce = value;
  },
  setHostedFields(state, value) {
    state.hostedFields = value;
  },
  setPaypalInstance(state, value) {
    state.paypalInstance = value;
  },
  setExpiration(state, value) {
    state.expiration = value;
  },
  setHasSetCoupon(state, value) {
    state.hasSetCoupon = value;
  },
  couponState(state, value) {
    state.couponState = value;
  },
  setTaxDetails(state, value) {
    state.fiscalCode = value.cod_fisc_pers || value.cod_fisc;
    state.cap = value.domicile_cap || value.piva_cap;
    state.taxDetailsAddress = value.domicile_address || value.piva_address;
    state.taxDetailsCity = value.domicile_city || value.piva_city;
    state.businessName = value.rag_soc;
    state.vatNumber = value.vat_number;
    state.sdiCode = value.addressee_code;
    state.pec = value.pec;
  },
  resetBookingDetails(state) {
    state.selectedHours = null;
    state.selectedZone = null;
    state.selectedAddress = null;
  },
  resetBookingState(state) {
    Object.assign(state, defaultState);
  },
  setEditingWashing(state, value) {
    state.editingWashing = value;
  },
  setEditingWashingState(state, value) {
    state.editingWashingState = value;
  },
  setDeletingWashingState(state, value) {
    state.deletingWashingState = value;
  },
  selectVehicleForWashing(state, value) {
    state.selectedVehicleForWashing = { ...value };
  },
  setNewVehicle(state, value) {
    state.newVehicle = { ...value };
  },
};

export const actions = {
  getZoneByCoords: async ({ commit }, { latitude, longitude }) => {
    const zone = await $getZoneByCoords({
      latitude,
      longitude,
    });

    if (zone.zones && zone.zones.id) {
      // SUCCESS
      commit("setZone", zone.zones.id);
    } else {
      // NOT COVERED
      commit("resetZone");
    }
  },
  getWashersByZone: async (
    { commit },
    { zoneId, latitude, longitude, date, duration }
  ) => {
    if (zoneId || (latitude && longitude)) {
      const zone = zoneId || (await $getZoneByCoords({ latitude, longitude }));
      const availability = await $getWashersByZone({
        zoneId: zone,
        date,
        duration,
      });
      commit("setAvailabilityHours", availability);
    }
  },
  getWashersByZoneWashOut2: async (
      { commit },
      { zoneId, latitude, longitude, date, executionTime }
  ) => {
    if (zoneId || (latitude && longitude)) {
      const zone = zoneId || (await $getZoneByCoords({ latitude, longitude }));
      const availability = await $getWashersByZoneWashOut2({
        zoneId: zone,
        date,
        executionTime,
      });
      commit("setAvailabilityHoursWashOut2", availability);
    }
  },
  resetBookingDetails: ({ commit, state }) => {
    commit("selectDay", null);
    commit("selectHours", {});
    commit("setPerformances", {
      performances: state.performances,
      selectedPerformances: [],
      performancesAccordions: [],
    });
  },
  getPerformances: async ({ commit, rootGetters}, washing ) => {
    const selectedModel = rootGetters["vehicleConfigurator/selectedModel"];
    const selectedVehicleType = rootGetters["vehicleConfigurator/selectedVehicleType"];
    const res = await $getPrices();
    let selectedPerformances = rootGetters["bookingFunnel/selectedPerformances"];
    const performancesByVehicleType = res.filter(
      ({ vehicle_type_id }) => {
        if (selectedModel && selectedVehicleType.customType === "Auto") {
          return (
            vehicle_type_id === selectedModel.vehicle_type_id
          );
        } else {
          return (
            vehicle_type_id === selectedVehicleType.id
          );
        }
      }
    );
    if(washing && (!selectedPerformances || !selectedPerformances.length)) {
      selectedPerformances = performancesByVehicleType.filter(x => washing.services.indexOf(x.title) > -1);
    }
    const performancesAccordions = performancesByVehicleType
      .map((service) => {
        return {
          option: service,
          isOpen: false,
          isSelected: service.service_title !== "Default" && selectedPerformances.find(x => x.id == service.id) != undefined,
          isOptional: service.service_name === "Igienizzazione",
          isVisible: service.service_title !== "Default",
        };
      });

    commit("setPerformances", {
      res,
      selectedPerformances,
      performancesAccordions,
    });
  },
  postRegistration: async ({ commit }, payload) => {
    const res = await $postRegistration(payload);
    commit("postRegistration", res);
  },
  patchRegistration: async ({ commit }, { payload, userId, token }) => {
    const res = await $patchRegistration(payload, userId, token);
    commit("patchRegistration", res);
  },
  postLogin: async ({ commit }, payload) => {
    const res = await $postLogin(payload);
    commit("postLogin", res);
  },
  sendResetPasswordMail: async ({ commit }, email) => {
    await $sendResetPasswordMail(email);
    commit("setResetPasswordMailSent", true);
  },
  requestMailVerificationCode: async ({ commit }, token) => {
    await $verifyEmailRequest(token);
    commit("lastMailVerificationCodeRequested", new Date().getTime());
  },
  requestPhoneVerificationCode: async ({ commit }, token) => {
    await $verifyPhoneRequest(token);
    commit("lastPhoneVerificationCodeRequested", new Date().getTime());
  },
  getUserData: async ({ commit }, { id, token, gtag }) => {
    const res = await $getUserData(id, token, gtag);
    commit("getUserData", res);
  },
  verifyEmailCode: async ({ commit }, { code, token }) => {
    const res = await $verifyEmailCode({ code }, token);
    commit("verifyEmailCode", res.client);
  },
  verifyPhoneCode: async ({ commit }, { code, token }) => {
    const res = await $verifyPhoneCode({ code }, token);
    commit("verifyPhoneCode", res.client);
  },
  reserveWashing: async ({ commit }, payload) => {
    const res = await $reserveWashing(payload);
    commit("reserveWashing", res);
  },
  getCouponsByCouponCode: async ({ commit }, { couponCode, token }) => {
    const res = await $getCouponsByCouponCode(couponCode, token);
    commit("getCouponsByCouponCode", res);
  },
  getCouponsByUserId: async ({ commit }, { userId, token }) => {
    const res = await $getCouponsByUserId(userId, token);
    commit("getCouponsByUserId", res);
  },
  postCoupon: async (
    { commit },
    { couponPayload, token, isPercentageAllowed = true }
  ) => {
    const res = await $postCoupon(couponPayload, token);
    if (res.result && res.result.code) {
      commit("setSelectedCoupon", res.result);
    } else {
      commit("setSelectedCoupon", null);
    }
    commit("couponState", res);
    commit(
      "setHasSetCoupon",
      res.result &&
        !!res.result.code &&
        (res.result.type !== "percentage" || isPercentageAllowed)
    );
  },
  getUsedCoupons: async ({ commit }, { userId, token }) => {
    const res = await $getUsedCoupons(userId, token);
    commit("getWashingsByUserId", res);
  },
  getBraintreeToken: async ({ commit }, token) => {
    const res = await $getBraintreeToken(token);
    commit("getBraintreeToken", res.token);
  },
  async initPaypal(
    context,
    { elementSelector, paypalCheckoutInstance, paypalPayment, paypalAuthorized }
  ) {
    EventBus.$emit("showSpinner", true);
    const paypal = await import("paypal-checkout");
    await paypal.Button.render(
      {
        env: paypalEnviroment,
        style: {
          label: "paypal",
          size: "responsive",
          shape: "rect",
        },
        payment: () => {
          return paypalPayment(paypalCheckoutInstance);
        },
        onAuthorize: (data) => {
          return paypalAuthorized(paypalCheckoutInstance, data);
        },
      },
      elementSelector
    );
    EventBus.$emit("showSpinner", false);
  },

  getNonce: ({ commit }, hostedFields) => {
    if (hostedFields) {
      hostedFields.tokenize().then(({ nonce }) => {
        commit("setNonce", nonce);
      });
    }
  },
  async initBraintree({ commit }, { authorization, braintreeDropInOptions/* , braintreeOptions */ }) {
    const braintree = await import("braintree-web");
    const dropIn = await import('braintree-web-drop-in');
    const instances = await braintree.client
      .create({ authorization })
      .then((clientInstance) => {
        return Promise.all([
          clientInstance,
          braintree.vaultManager.create({
            client: clientInstance,
            authorization
          }),
          dropIn.create(
            {
              authorization,
              ...braintreeDropInOptions,
              onPaymentMethodReceived: function (card) { // eslint-disable-line
                // console.log('received', card);
              }
            }
          ),
          /* braintree.hostedFields.create({
            client: clientInstance,
            ...braintreeOptions,
          }), */
          braintree.paypalCheckout.create({ client: clientInstance }),
        ]);
      });
    const vaultManagerInstance = instances[1]; 
    const dropInInstance = instances[2];
    await vaultManagerInstance.fetchPaymentMethods();
    const paypalInstance = instances[3];
    commit("setPaypalInstance", paypalInstance);
    return dropInInstance;
  },
  editWashing: async ({ commit }, { washingId, washingEdits, token }) => {
    const res = await $editWashing(washingId, washingEdits, token);
    commit("setEditingWashingState", res);
  },
  deleteWashing: async ({ commit }, { washingId, token }) => {
    const res = await $deleteWashing({ id: washingId }, token);
    commit("setDeletingWashingState", res);
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
